import LinkComponent, { LinkComponentLink } from '@spa/components/link/link.component';
import React, { ReactNode } from 'react';
import classNames from 'clsx';
import styles from './bubble-button.component.module.scss';

export enum BubbleType {
  BUTTON,
  LINK
}

interface LinkProps {
  readonly type: BubbleType.LINK;
  readonly link: LinkComponentLink;
  readonly isHighlighted: boolean;
  readonly text: string;
}

interface ButtonProps {
  readonly type: BubbleType.BUTTON;
  readonly isHighlighted: boolean;
  readonly onClick: () => void;
  readonly text: string;
}

export type Props = ButtonProps | LinkProps;

function BubbleButtonComponent(props: Props): ReactNode {
  const { type, isHighlighted, text } = props;
  const tabButtonsClassnames: string = classNames(styles['bubble-component'], {
    [styles['bubble-component--highlighted']]: isHighlighted
  });

  const element = (): ReactNode => {
    let result: ReactNode;
    switch (type) {
      case BubbleType.BUTTON:
        const { onClick }: ButtonProps = props;
        result = (
          <button className={tabButtonsClassnames} onClick={onClick} type={'button'}>
            {text}
          </button>
        );
        break;
      case BubbleType.LINK:
        const { link }: LinkProps = props;
        result = (
          <div className={tabButtonsClassnames}>
            <LinkComponent link={link}>
              <span>{text}</span>
            </LinkComponent>
          </div>
        );
        break;
      default:
        throw new Error('Bubble type not supported: ', type);
    }

    return result;
  };

  return element();
}

export default BubbleButtonComponent;
